import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bugcrowd = defineConnector({
  identifier: "bugcrowd",
  name: "Bugcrowd",
  tagLine: "Crowdsourced security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.bugcrowd\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "Token",
      },
      {
        name: "Accept",
        value: "application/vnd.bugcrowd+json",
      },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into [Bugcrowd](https://bugcrowd.com/), click on your profile picture, and select **API Credentials** from the dropdown menu. Enter a descriptive name and click **Create API Credentials**.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Bugcrowd API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
          helperText: "The token from your API credentials.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.bugcrowd.com/organizations",
  },
});
